@let lastSave = lastSave$ | async;
@let retryCount = retryCount$ | async;

@if (lastSave || retryCount) {
  <span class="breadcrumb-divider">|</span>
  <div class="label-container" [class.danger]="retryCount && retryCount > 10">
    @if (retryCount) {
      Saving failed... retrying
      @if (retryCount > 1) {
        ({{ retryCount }})
      }
    } @else {
      Last saved
      <strong>{{ lastSave }}</strong>
      ago
    }
  </div>
}
